import { Tag, TagStatus } from "@magnetic/tag";

import { BaseColumnConfig } from "./baseColumnConfig";

const latencyStatus = (ms: number): TagStatus => {
  if (ms >= 1000) return "negative";
  if (ms >= 500) return "warning";
  if (ms >= 200) return "info";
  return "positive";
};

export class LatencyColumn extends BaseColumnConfig<number> {
  compare(a: number = 0, b: number = 0) {
    return a - b;
  }
  render(value: number = 0) {
    return (
      <Tag.Status status={latencyStatus(value)}>{`${value}ms`}</Tag.Status>
    );
  }
}
